import { useMemo } from "react";
import { useCartStore } from "../store/useCartStore";
import { getCartBadgeCount, getCartCount, getCartTotal } from "../utils/cartCalculations";

export const useCart = () => {
    const cartItems = useCartStore((state) => state.items);
    const isCartOpen = useCartStore((state) => state.isOpen);
    const isReconciling = useCartStore((state) => state.isReconciling);
    const lastPricingContext = useCartStore((state) => state.lastPricingContext);
    const lastReconciledAt = useCartStore((state) => state.lastReconciledAt);
    const reconciliationError = useCartStore((state) => state.reconciliationError);
    const reconciliationChanges = useCartStore((state) => state.reconciliationChanges);

    const addToCart = useCartStore((state) => state.addToCart);
    const removeFromCart = useCartStore((state) => state.removeFromCart);
    const updateQuantity = useCartStore((state) => state.updateQuantity);
    const clearCart = useCartStore((state) => state.clearCart);
    const applyOperations = useCartStore((state) => state.applyOperations);
    const validateAndRepairCart = useCartStore((state) => state.validateAndRepairCart);
    const reconcilePrices = useCartStore((state) => state.reconcilePrices);
    const openCart = useCartStore((state) => state.openCart);
    const closeCart = useCartStore((state) => state.closeCart);
    const toggleCart = useCartStore((state) => state.toggleCart);

    const cartCount = useMemo(() => getCartCount(cartItems), [cartItems]);
    const cartBadgeCount = useMemo(() => getCartBadgeCount(cartItems), [cartItems]);
    const cartTotal = useMemo(() => getCartTotal(cartItems), [cartItems]);

    return {
        cartItems,
        cartCount,
        cartBadgeCount,
        cartTotal,
        isCartOpen,
        isReconciling,
        lastPricingContext,
        lastReconciledAt,
        reconciliationError,
        reconciliationChanges,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        applyOperations,
        validateAndRepairCart,
        reconcilePrices,
        openCart,
        closeCart,
        toggleCart,
    };
};
